module.exports = __webpack_public_path__ + "img/fiqueok_check.e7a6dfc3.png";